import React from 'react';
import dayjs from 'dayjs';
import {
  RPCDocs,
  Alerts,
  type DownloadPdfResult,
  useDownloadsApiServiceContext,
  useToggle,
} from '@therms/react-modules'
import {
  Button,
  Icon,

  Loading,
  toastManager,
  Tooltip } from
'@therms/atalaya';
import {downloadBase64AsPdf} from '@therms/web-js';
import {ReportTitle} from './ReportTitle';
import {ShowStatusHistoryModal} from './ShowStatusHistoryModal';
import {MdRefresh} from 'react-icons/md';
import {IoMdDownload} from 'react-icons/io';

interface Props {
  loading?: boolean;
  report: RPCDocs.Reports.GetReport.v1.Report;
}

function ReportHeaderSection({loading, report}: Props) {
  const {client} = useDownloadsApiServiceContext()
  const [showStatusHistoryModal, toggleShowStatusHistoryModal] =
  useToggle(false);

  const handleDownloadReportPDF = () => {
    const toastId = Alerts.info(
      <div>
        <Icon Icon={MdRefresh} spin /> Starting download, please wait...
      </div>,
      {autoClose: false, position: 'top-center'}
    );

    client.reports.DownloadReport({body: {reportId: report.id}})
      .then((response) => {
        const result = response as DownloadPdfResult
        if (result.pdfBase64) {
          downloadBase64AsPdf(
            `${dayjs(report.date).format()} ${report.title} ${
              report.subTitle
            } ${report.authors
              ?.map(({displayName}) => displayName)
              .join(', ')}`,
            result.pdfBase64,
          )
        }
      })
      .catch((err: any) => {
        console.error('err downloading report', err)
      })
      .finally(() => toastManager.dismiss(toastId))
  }

  return (
    <>
      <div>
        {loading && !report && <Loading overlay />}

        <div className="inline-flex justify-between gap-x-sm w-full">
          <ReportTitle report={report} />

          <Tooltip tooltip="Download Report as PDF">
            <Button onClick={handleDownloadReportPDF} subtle>
              <Icon Icon={IoMdDownload} />
            </Button>
          </Tooltip>
        </div>
      </div>

      {showStatusHistoryModal &&
      <ShowStatusHistoryModal
        closeHandler={toggleShowStatusHistoryModal}
        report={report} />

      }
    </>);

}

export { ReportHeaderSection };